import hljs from "highlight.js/lib/core";
import c from "highlight.js/lib/languages/c";
import csharp from "highlight.js/lib/languages/csharp";
import cpp from "highlight.js/lib/languages/cpp";
import css from "highlight.js/lib/languages/css";
import html from "highlight.js/lib/languages/xml";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import matlab from "highlight.js/lib/languages/matlab";
import python from "highlight.js/lib/languages/python";
import r from "highlight.js/lib/languages/r";
import sql from "highlight.js/lib/languages/sql";
import { aspnet, extendJava, extendMatlab } from "./languageUtils";

let registered = false;

function registerCodeBlockLanguages(): void {
  if (registered) return;
  registered = true;

  hljs.registerLanguage("c", c);
  hljs.registerLanguage("csharp", csharp);
  hljs.registerLanguage("cpp", cpp);
  hljs.registerLanguage("css", css);
  hljs.registerLanguage("html", html);
  hljs.registerLanguage("java", java);
  hljs.registerLanguage("javascript", javascript);
  hljs.registerLanguage("matlab", matlab);
  hljs.registerLanguage("python", python);
  hljs.registerLanguage("r", r);
  hljs.registerLanguage("sql", sql);

  hljs.registerLanguage("aspnet", aspnet);
  hljs.registerLanguage("matlab", extendMatlab);
  hljs.registerLanguage("java", extendJava);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hljs.registerLanguage(
    "plaintext",
    () => ({ name: "Plain text", disableAutodetect: true } as any),
  );
}

registerCodeBlockLanguages();

export { hljs };
